import axios from 'axios';

const token = document.querySelector('[name="csrf-token"]') || {content: 'no-csrf-token'};
const AxiosApi = axios.create({
  headers: {
    common: {
      'X-CSRF-Token': token.content
    }
  },
  withCredentials: true,
});

const Api = {
  getCurrentUser() {
    return AxiosApi.get('/api/v1/get_current_user')
      .then(({data}) => data)
      .catch((errors) =>
        console.log(errors)
      )
  },
  postNewUser(data) {
    return AxiosApi.post('/users', data)
      .then(({data}) => data)
      .catch((errors) =>
        console.log(errors)
      )
  },
  getExpertises() {
    return AxiosApi.get('/api/v1/expertises')
      .then(({data}) => data['data'])
      .catch((errors) =>
        console.log(errors)
      )
  },
  getOrganizations(params) {
    return AxiosApi.get('/api/v1/organizations', {params: params})
      .then(({data}) => data['data'])
      .catch((errors) =>
        console.log(errors)
      )
  },
  getSessionInfo() {
    return AxiosApi.get('/api/v1/get_session_info')
      .then(({data}) => data['data'])
      .catch((errors) => {
          console.log(errors)
          return {}
      });
  },
  getProfileInfo(id) {
    return AxiosApi.get(`/api/v1/get_profile_info?id=${id}` )
      .then(({data}) => data)
      .catch((errors) =>
        console.log(errors)
      )
  },
  getCurrentOrganizationRole() {
    return AxiosApi.get('/api/v1/get_current_organization_role')
      .then(({data}) => data['data'])
      .catch((errors) =>
        console.log(errors)
      )
  },
  updateProfileDetails(data, id) {
    return AxiosApi.patch(
      `/api/v1/users/${id}`,
      data,
      ).then(({data}) => data['data'])
      .catch((errors) =>
        console.log(errors)
      )
  },
  getOrganization(id) {
    return AxiosApi.get(`/api/v1/organizations/${id}`)
      .then(({data}) => data)
      .catch((errors) =>
        console.log(errors)
      )
  },
  getPolities(params = {}) {
    return AxiosApi.get('/api/v1/polities', {params: params})
      .then(({data}) => data['data'])
      .catch((errors) =>
        console.log(errors)
      )
  },
  getPolity(id) {
    return AxiosApi.get(`/api/v1/polities/${id}`)
      .then(({data}) => data['data'])
      .catch((errors) =>
        console.log(errors)
      )
  },
  postNewExpertise(data) {
    return AxiosApi.post('/api/v1/expertises', data)
      .then(({data}) => data['data'])
      .catch((errors) =>
        console.log(errors)
      )
  },
  postNewInterest(data) {
    return AxiosApi.post('/api/v1/interests', data)
      .then(({data}) => data['data'])
      .catch((errors) =>
        console.log(errors)
      )
  },
  postNewAreaOfExperience(data) {
    return AxiosApi.post('/api/v1/experiences', data)
      .then(({data}) => data['data'])
      .catch((errors) =>
        console.log(errors)
      )
  },
  updateOrgDetails(data, id) {
    return AxiosApi.patch(
      `/api/v1/organizations/${id}`,
      data,
      { headers: {'Content-Type': data.get('logo') ? data.get('logo').type : 'application/json'} }
      )
      .then(({data}) => data['data'])
      .catch((errors) =>
        console.log(errors)
      )
  },
 updateExpertise(data) {
    return AxiosApi.patch(`/api/v1/expertises/${data.id}`, data)
      .then(({data}) => data['data'])
      .catch((errors) =>
        console.log(errors)
      )
  },
  updateInterest(data) {
    return AxiosApi.patch(`/api/v1/interests/${data.id}`, data)
      .then(({data}) => data['data'])
      .catch((errors) =>
        console.log(errors)
      )
  },
  updateAreaOfExperience(data) {
    return AxiosApi.patch(`/api/v1/experiences/${data.id}`, data)
      .then(({data}) => data['data'])
      .catch((errors) =>
        console.log(errors)
      )
  },
  deleteExpertise(id) {
    return AxiosApi.delete(`/api/v1/expertises/${id}`)
      .then(({data}) => data['data'])
      .catch((errors) =>
        console.log(errors)
      )
  },
  deleteInterest(id) {
    return AxiosApi.delete(`/api/v1/interests/${id}`)
      .then(({data}) => data['data'])
      .catch((errors) =>
        console.log(errors)
      )
  },
  deleteAreaOfExperience(id) {
    return AxiosApi.delete(`/api/v1/experiences/${id}`)
      .then(({data}) => data['data'])
      .catch((errors) =>
        console.log(errors)
      )
  },
  getMapData(data) {
    return AxiosApi.get('/api/v1/get_polities_for_world_map', {params: data})
      .then(({data}) => data['data'])
      .catch((errors) =>
        console.log(errors)
      )
  },
  getResourcesMapData(data) {
    return AxiosApi.get('/api/v1/get_polity_resources_for_world_map', {params: data})
      .then(({data}) => data['data'])
      .catch((errors) =>
        console.log(errors)
      )
  },
  postNewResource(data) {
    return AxiosApi.post('/api/v1/resources', data)
      .then(({data}) => data['data'])
      .catch((errors) =>
        console.log(errors)
      )
  },
  getResources() {
    return AxiosApi.get('/api/v1/resources')
      .then(({data}) => data)
      .catch((errors) =>
        console.log(errors)
      )
  },
  deleteResource(id) {
    return AxiosApi.delete(`/api/v1/resources/${id}`)
      .then(({data}) => data['data'])
      .catch((errors) =>
        console.log(errors)
      )
  },
  updateResource(data) {
    return AxiosApi.patch(`/api/v1/resources/${data.id}`, data)
      .then(({data}) => data['data'])
      .catch((errors) =>
        console.log(errors)
      )
  },
  getResourceTypes() {
    return AxiosApi.get('/api/v1/resource_types')
      .then(({data}) => data)
      .catch((errors) =>
        console.log(errors)
      )
  },
  getMediaTypes() {
    return AxiosApi.get('/api/v1/media_types')
      .then(({data}) => data)
      .catch((errors) =>
        console.log(errors)
      )
  },
  getResourceTags() {
    return AxiosApi.get('/api/v1/tag_list')
      .then(({data}) => data)
      .catch((errors) =>
        console.log(errors)
      )
  },
  postNewMessage(data) {
    return AxiosApi.post('/api/v1/messages', data)
      .then(({data}) => data['data'])
      .catch((errors) =>
        console.log(errors)
      )
  },
  getConnector(data) {
    return AxiosApi.get('/api/v1/get_connector', {params: data})
      .then(({data}) => data)
      .catch((errors) =>
        console.log(errors)
      )
  },
  postNewConnection(data) {
    return AxiosApi.post('/api/v1/connections', data)
      .then(({data}) => data)
      .catch((errors) =>
        console.log(errors)
      )
  },
  updatePendingConnection(data) {
    return AxiosApi.patch(`/api/v1/connections/${data.connectee_id}`, data)
      .then(({data}) => data)
      .catch((errors) =>
        console.log(errors)
      )
  },
  searchUsers(data) {
    return AxiosApi.get('/api/v1/get_filtered_users', {params: data})
      .then(({data}) => data)
      .catch((errors) =>
        console.log(errors)
      )
  },
  getUsers(page) {
    return AxiosApi.get('/api/v1/users', {params: {page: page}})
      .then(({data}) => data)
      .catch((errors) =>
        console.log(errors)
      )
  },
  postNewConversation(data) {
    return AxiosApi.post('/api/v1/conversations', data)
      .then(({data}) => data['data'])
      .catch((errors) =>
        console.log(errors)
      )
  },
  postNewConversationMessage(data) {
    return AxiosApi.post('/api/v1/conversation_messages', data)
      .then(({data}) => data)
      .catch((errors) =>
        console.log(errors)
      )
  },
  findOrCreateConversation(data) {
    return AxiosApi.post('/api/v1/find_or_create_conversation', data)
      .then(({data}) => data)
      .catch((errors) =>
        console.log(errors)
      )
  },
  favoriteResource(data) {
    return AxiosApi.post('/api/v1/favorites', data)
      .then(({data}) => data)
      .catch((errors) =>
        console.log(errors)
      )
  },
  unfavoriteResource(id) {
    return AxiosApi.delete(`/api/v1/favorites/${id}`)
      .then(({data}) => data)
      .catch((errors) =>
        console.log(errors)
      )
  },
  markAsRead(data) {
    return AxiosApi.patch('/api/v1/mark_as_read', data)
      .then(({data}) => data)
      .catch((errors) =>
        console.log(errors)
      )
  },
  getResourceFavoritors(id) {
    return AxiosApi.get('/api/v1/get_resource_favoritors/', {params: {id: id}})
      .then(({data}) => data)
      .catch((errors) =>
        console.log(errors)
      )
  },
  getFavoriteResourcesForUser(params) {
    return AxiosApi.get('/api/v1/get_favorite_resources_for_user', {params: params})
      .then(({data}) => data)
      .catch((errors) =>
        console.log(errors)
      )
  },
  postNewOrganizationResource(data) {
    return AxiosApi.post('/api/v1/organization_resources', data)
      .then(({data}) => data)
      .catch((errors) =>
        console.log(errors)
      )
  },
  requestUpload(data) {
    return AxiosApi.post('/api/v1/files', data)
      .then(({data}) => data)
      .catch((errors) =>
        console.log(errors)
      )
  },
  deleteOrganizationResource(id, orgId) {
    return AxiosApi.delete(`/api/v1/organization_resources/${id}`, {params: {organization_id: orgId}})
      .then(({data}) => data)
      .catch((errors) =>
        console.log(errors)
      )
  },
  uploadToS3(data, file) {
    const formData = new FormData()

    for (const key in data.url_fields) {
      formData.append(key, data.url_fields[key])
    }

    formData.append('file', file)

    return AxiosApi.post(data.url, formData)
      .then(({data}) => data)
      .catch((errors) =>
        console.log(errors)
      )
  },
  updateOrganizationResource(data) {
    return AxiosApi.patch(`/api/v1/organization_resources/${data.id}`, data)
      .then(({data}) => data)
      .catch((errors) =>
        console.log(errors)
      )
  },
  updateUserSettings(data) {
    return AxiosApi.patch('/api/v1/update_user_settings', data)
      .then(({data}) => data)
      .catch((errors) =>
        console.log(errors)
      )
  },
  searchPolityResources(data) {
    return AxiosApi.get('/api/v1/filter_polity_resources', {params: data})
      .then(({data}) => data)
      .catch((errors) =>
        console.log(errors)
      )
  },
  postNewInvitation(data) {
    return AxiosApi.post('/api/v1/invitations', data)
      .then(({data}) => data)
      .catch((errors) =>
        console.log(errors)
      )
  },
  postNewForumMessage(data) {
    return AxiosApi.post('/api/v1/forum_messages', data)
      .then(({data}) => data)
      .catch((errors) =>
        console.log(errors)
      )
  },
  toggleActiveTyping(data) {
    return AxiosApi.get('/api/v1/toggle_active_typing', {params: data})
      .then(({data}) => data)
      .catch((errors) =>
        console.log(errors)
      )
  },
  updateMessage(data) {
    return AxiosApi.patch(`/api/v1/messages/${data.id}`, data)
      .then(({data}) => data)
      .catch((errors) =>
        console.log(errors)
      )
  },
  deleteMessage(data) {
    return AxiosApi.patch('/api/v1/soft_delete_message', data)
      .then(({data}) => data)
      .catch((errors) =>
        console.log(errors)
      )
  },
  like(data) {
    return AxiosApi.post('/api/v1/like', data)
      .then(({data}) => data)
      .catch((errors) =>
        console.log(errors)
      )
  },
  unlike(data) {
    return AxiosApi.delete('/api/v1/unlike', {params: data})
      .then(({data}) => data)
      .catch((errors) =>
        console.log(errors)
      )
  },
  postNewReply(data) {
    return AxiosApi.post('/api/v1/create_reply', data)
      .then(({data}) => data)
      .catch((errors) =>
        console.log(errors)
      )
  },
  postNewForumSuggestion(data) {
    return AxiosApi.post('/api/v1/forum_suggestion', data)
      .then(({data}) => data)
      .catch((errors) =>
        console.log(errors)
      )
  },
  followForum(data) {
    return AxiosApi.post('/api/v1/follow_forum', data)
      .then(({data}) => data)
      .catch((errors) =>
        console.log(errors)
      )
  },
  unfollowForum(data) {
    return AxiosApi.delete('/api/v1/unfollow_forum', {params: data})
      .then(({data}) => data)
      .catch((errors) =>
        console.log(errors)
      )
  },
  updateFollow(data) {
    return AxiosApi.patch('/api/v1/update_follow_preference', data)
      .then(({data}) => data)
      .catch((errors) =>
        console.log(errors)
      )
  },
  syncEventParticipants(data) {
    return AxiosApi.post('/api/v1/sync_event_participants', data)
      .then(({data}) => data)
      .catch((errors) =>
        console.log(errors)
      )
  }
};

export default Api;
